import { useMemo } from 'react'
import { isEmpty, concat, sortBy } from 'lodash'
import {
  summarizeParticipantsDataByPlanTaxableAccounts,
  sumUpParticipantsSummaryDataTaxableAccounts,
  createParticipantsSummaryOverviewRowTaxableAccounts,
} from 'utils'

function useParticipantsSummaryTaxableAccounts(participants) {
  const [participantsSummaryData, participantsSummaryOverview] = useMemo(() => {
    if (isEmpty(participants)) return [[], []]

    const summaryDataByPlan =
      summarizeParticipantsDataByPlanTaxableAccounts(participants)
    const summaryOverview =
      sumUpParticipantsSummaryDataTaxableAccounts(summaryDataByPlan)
    const summaryOverviewRow =
      createParticipantsSummaryOverviewRowTaxableAccounts(summaryOverview)

    return [
      concat(sortBy(summaryDataByPlan, 'planName'), summaryOverviewRow),
      summaryOverview,
    ]
  }, [participants])

  return {
    data: participantsSummaryData,
    overview: participantsSummaryOverview,
  }
}

export default useParticipantsSummaryTaxableAccounts
